import React from 'react';
import { Typography } from '@mui/material';
import moment from 'moment';
import { YardReciptData } from '@Src/_basic/object/YardReceiptsType';

interface Props {
  row: YardReciptData;
}
export default function CreateTimeColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{moment(row.createTime).format('YYYY/MM/DD HH:mm')}</Typography>;
}
